import { useEffect } from 'react';

export default function useTitle(title) {
    
    useEffect(() => {
        document.title = `Gujarati NRI Matrimony | ${title}`
    }, [title]);

    return null;
}